import { render, staticRenderFns } from "./BookingDelivery.vue?vue&type=template&id=0bfd1341"
import script from "./BookingDelivery.vue?vue&type=script&lang=js"
export * from "./BookingDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports